import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { KlaviyoForm } from '@/scripts/theme/klaviyo-form'
import { ModalDialog } from '@/scripts/theme/modal-dialog'

export class WaitlistForm extends UcoastEl {
	static htmlSelector = 'waitlist-form'
	form: HTMLFormElement
	submitButton: HTMLButtonElement
	emailInput: HTMLInputElement
	variantInput: HTMLInputElement
	variant?: string
	successMessage: string
	errorMessage: string
	companyId: string
	productTitle: string | undefined
	constructor() {
		super()
		this.form = q.rs('form', this)
		this.submitButton = q.rs('[type="submit"]', this)
		this.variantInput = q.rs('[name="variant"]', this)
		this.emailInput = q.rs('[type="email"]', this)
		this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
		this.successMessage = q.ra(this, 'data-success')
		this.errorMessage = q.ra(this, 'data-error')
		this.companyId = q.ra(this, 'data-company-id')
		this.productTitle = q.oa(this, 'data-product-title')

		if (this.productTitle) {
			this.updateProductTitle(this.productTitle)
		}
	}

	getTitleElement() {
		return this.closest('.product-popup-modal__content-info')
			?.querySelector<HTMLElement>('.product-title')
	}

	updateProductTitle(productTitle?: string) {
		const titleEl = this.getTitleElement()
		if (titleEl) {
			titleEl.textContent = productTitle ?? ''
		}
	}

	onSubmitHandler(event: Event) {
		event.preventDefault()
		if (this.submitButton.getAttribute('aria-disabled') === 'true') return
		if (this.emailInput.value.length < 1) return

		this.submitButton.setAttribute('aria-disabled', 'true')
		this.submitButton.classList.add('loading')

		const formData = new FormData(this.form)
		const listFormData = new FormData(this.form)

		Promise.resolve()
			.then(() => {
				const requests = [
					fetch(
						`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.companyId}`,
						this.notifyMeConfig(formData)
					),
				]
				const listId = listFormData.get('list_id')
				if (listId) {
					const listConfig = KlaviyoForm.addToKlaviyoListConfig(listFormData)
					requests.push(
						fetch(
							`https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`,
							listConfig
						)
					)
				}
				return Promise.all(requests)
			})
			.then(async (responses) => {
				const failedResponse = responses.find((response) => !response.ok)
				if (!failedResponse) return
				const responseBody = await failedResponse.text()
				throw new Error(
					responseBody || `Klaviyo request failed: ${failedResponse.status}`
				)
			})
			.then((_) => {
				this.emailInput.value = ''
				this.submitButton.classList.add('success')
				this.emailInput.placeholder = this.successMessage
				window.setTimeout(() => {
					q.rs<ModalDialog>('#WaitlistModal')?.hide()
				}, 5000)
			})
			.catch((e) => {
				this.emailInput.placeholder = this.errorMessage
				console.error(e)
			})
			.finally(() => {
				this.submitButton.classList.remove('loading')
				this.submitButton.removeAttribute('aria-disabled')
			})
	}
	notifyMeConfig(body: FormData) {
		const variant = q.rfd(body, 'variant')
		const data = {
			data: {
				type: 'back-in-stock-subscription',
				attributes: {
					profile: {
						data: {
							type: 'profile',
							attributes: {
								email: q.rfd(body, 'email'),
							},
						},
					},
					channels: ['EMAIL'],
				},
				relationships: {
					variant: {
						data: {
							type: 'catalog-variant',
							id: `$shopify:::$default:::${variant}`,
						},
					},
				},
			},
		}
		return {
			method: 'POST',
			mode: 'cors' as RequestMode,
			headers: {
				'Content-Type': 'application/json',
				'Revision': '2026-07-15',
			},
			body: JSON.stringify(data),
		}
	}

}
